import { Flex, Text, Image } from "@chakra-ui/react";
import ButtonSpoleto from "../Button";
import TitleSpoleto from "../Title";
import { CloseIcon  } from '@chakra-ui/icons'

const ErrorModalBody = ({ closeModal }) => {
  return (
    <Flex
      w="100%"
      py={12}
      flexDirection="column"
      alignItems="center"
      textAlign="center"
    >
      <CloseIcon color="#fff" w={16} h={16} />
      <TitleSpoleto
        textAlign="center"
        color="#EFEBE1"
        fontSize={["30px", null, "40px"]}
        mb={0}
        mt={12}
      >
        ERRO
      </TitleSpoleto>
      <Text
        mt={4}
        mb={8}
        fontFamily="FiraSansRegular"
        fontSize="22px"
        color="#FDF6DC"
        maxW="80%"
        textAlign="center"
      >
        Desculpe, aconteceu um erro e não foi possível finalizar o seu voto. tente novamente mais tarde.
      </Text>
      <ButtonSpoleto
        backgroundColor="#331F12"
        color="#fff"
        shadow="0 0 0 2px #331F12"
        maxWidth={["75%", null, "90%"]}
        onClick={closeModal}
      >
        Fechar
      </ButtonSpoleto>
    </Flex>
  );
};

export default ErrorModalBody;
